import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Flex, Icon, Typography, Tooltip as LegoTooltip } from "@ugc-ui/lego";
import {
  StatisticChartContainer,
  StatisticChartTitle,
} from "@client/pages/ShowCampaign/ShowCampaign.styled";
import { internationalFormatNum } from "@common/utils/number";
import { DefaultTooltip } from "@common/components/Statistic/DefaultTooltip";

type Props = {
  chartData: any[];
  dataKey: string;
  title: string;
  totalValue: number;
  tooltipText: string;
};

export const StatisticChart = ({
  chartData,
  dataKey,
  title,
  tooltipText,
  totalValue,
}: Props) => (
  <StatisticChartContainer>
    <StatisticChartTitle justifyContent="space-between">
      <Flex alignItems="center" gap={5}>
        <Typography type="tablebody" color="rgba(223, 223, 223, 1)">
          {title}
        </Typography>
        <LegoTooltip title={tooltipText} color="default" placement="bottomLeft">
          <Flex alignItems="center">
            <Icon icon="help" size="extraSmall" />
          </Flex>
        </LegoTooltip>
      </Flex>
      <Typography type="tablebody" color="rgba(0, 229, 188, 1)">
        {internationalFormatNum(totalValue)}
      </Typography>
    </StatisticChartTitle>
    <ResponsiveContainer width="100%" height={200}>
      <BarChart
        data={chartData}
        width={1000}
        height={1000}
        margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
      >
        <CartesianGrid strokeDasharray="3 3" syncWithTicks />
        <XAxis
          dataKey="date"
          tick={{ fontFamily: "Roboto, sans-serif", fontSize: "12px" }}
        />
        <YAxis
          tickFormatter={internationalFormatNum}
          tick={{ fontFamily: "Roboto, sans-serif" }}
        />
        <Bar dataKey={dataKey} fill="rgba(0, 229, 188, 1)" />
        <Tooltip
          cursor={{ fill: "rgba(206, 206, 206, 0.3)" }}
          content={<DefaultTooltip />}
        />
      </BarChart>
    </ResponsiveContainer>
  </StatisticChartContainer>
);
